import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { postApplicationRequirementFromTemplateAction } from "../../api/jsonapi";
import { applicationIdSelector } from '@applyboard/ab-common';
import handleApiErrorResponse from "../../util/handleApiErrorResponse";
var enhancer = compose(connect(function (state) {
  return {
    application_id: applicationIdSelector(state)
  };
}, function (dispatch) {
  return {
    addRequirementToApplication: function addRequirementToApplication(application_id, requirement_template_id) {
      return dispatch(postApplicationRequirementFromTemplateAction({
        application_id: application_id
      }, {
        data: {
          attributes: {
            requirement_template_id: requirement_template_id
          }
        }
      }));
    }
  };
}), withHandlers({
  handleConfirmAddRequirement: function handleConfirmAddRequirement(_ref) {
    var application_id = _ref.application_id,
      addRequirementToApplication = _ref.addRequirementToApplication;
    return function (ids) {
      if (_typeof(ids) == 'object') {
        var promises = Object.keys(ids).map(function (id) {
          addRequirementToApplication(application_id, id)["catch"](handleApiErrorResponse);
        });
        return Promise.all(promises);
      } else {
        return addRequirementToApplication(application_id, ids)["catch"](handleApiErrorResponse);
      }
    };
  }
}));
export default enhancer;